// Shared constants for sales components

export const stageBadges = {
  presale_create: null,
  presale_confirm: { label: 'Tracking Deliverables', className: 'bg-yellow-100 text-yellow-700' },
  presale_deliverables: { label: 'Tracking Deliverables', className: 'bg-yellow-100 text-yellow-700' },
  presale_ready: { label: 'Ready for Sale', className: 'bg-green-100 text-green-700' },
  live_sale: { label: 'Live Sale', className: 'bg-primary text-white' },
  post_sale: { label: 'Complete', className: 'bg-muted text-muted-foreground' },
};

export const entryConfirmedBadge  = { label: 'Entry Confirmed',     className: 'bg-blue-100 text-blue-700' };
export const enteredBadge          = { label: 'Entered',             className: 'bg-orange-100 text-orange-700' };
export const potentialSaleEntryBadge = { label: 'Potential Sale Entry', className: 'bg-gray-100 text-gray-700' };
export const outBadge              = { label: 'OUT',                 className: 'bg-red-100 text-red-700 font-bold' };
export const notAcceptedBadge      = { label: 'Not Accepted',        className: 'bg-red-100 text-red-700' };
export const withdrawnBadge        = { label: 'Withdrawn',           className: 'bg-red-100 text-red-700' };

const POTENTIAL_ENTRY_STATUSES = new Set(['not_yet_entered', 'nominated', 'still_under_consideration', 'accepted', '', null, undefined]);
export const showPotentialSaleEntry = (entryStatus) => POTENTIAL_ENTRY_STATUSES.has(entryStatus);
export const showEntered = (entryStatus) => entryStatus === 'entered';
export const showOut = (entryStatus) => entryStatus === 'out' || entryStatus === 'recommended_another_sale';
export const showNotAccepted = (entryStatus) => entryStatus === 'recommended_another_sale';
export const showWithdrawn = (entryStatus) => entryStatus === 'withdrawn' || entryStatus === 'out';

export const typeLabels = {
  'breeding_soundness_exam': 'Breeding Soundness Exam',
  'catalogue_page': 'Catalogue Page',
  'coggins': 'Coggins',
  'entry_fee': 'Entry Fee',
  'eva': 'EVA',
  'eye_certificate': 'Eye Certificate',
  'fetal_sexing': 'Fetal Sexing',
  'health_certificate': 'Health Certificate',
  'image': 'Image',
  'jockey_club_papers': 'Jockey Club Papers',
  'medication_treatment_disclosure': 'Medication & Treatment Disclosure',
  'pedigree_proof': 'Pedigree Proof',
  'questionnaire': 'Questionnaire',
  'scope': 'Scope',
  'stallion_service_certificate': 'Stallion Service Certificate',
  'surgery_letter': 'Surgery Letter',
  'vet_report': 'Vet Report',
  'video': 'Video',
  'xrays': 'Xrays',
  'other': 'Other',
  'sale_company_contract': 'Sale Company Contract',
  'sale_authorization': 'Sale Authorization',
  'consignment_contract': 'Consignment Contract',
  'hip_number_email': 'Hip Number Email',
  'ship_in_note_email': 'Ship-in Note Email',
  'seller_thank_you': 'Seller Thank You',
};

export const statusIcons = {
  not_started: require('lucide-react').Circle,
  in_progress: require('lucide-react').Clock,
  completed: require('lucide-react').CheckCircle2,
  blocked: require('lucide-react').AlertCircle,
  on_hold: require('lucide-react').PauseCircle,
  cancelled: require('lucide-react').XCircle,
};

export const statusColors = {
  not_started: 'text-gray-400',
  in_progress: 'text-blue-500',
  completed: 'text-green-500',
  blocked: 'text-red-500',
  on_hold: 'text-yellow-600',
  cancelled: 'text-red-700',
};

export const formatCurrency = (amount, currency = 'USD') => {
  if (!amount) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
  }).format(amount);
};


// Display labels for sold_as — exact capitalisation required (HORA, 2YO, etc.)
const SOLD_AS_LABELS = {
  weanling: 'Weanling',
  yearling: 'Yearling',
  '2yo': '2YO',
  hora: 'HORA',
  broodmare: 'Broodmare',
  broodmare_prospect: 'Broodmare Prospect',
  racing_broodmare_prospect: 'Racing Broodmare Prospect',
  racing_prospect: 'Racing Prospect',
  stallion: 'Stallion',
  stallion_prospect: 'Stallion Prospect',
  racing_stallion_prospect: 'Racing Stallion Prospect',
};
export const formatSoldAs = (value) => {
  if (!value) return '-';
  return SOLD_AS_LABELS[value] || value.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};
